import { ReactNode } from 'react';
import { create } from 'zustand';

interface ContextCustomType {
  isOpen: boolean;
  loading: boolean;
  contents?: string | ReactNode;
  pageY: number;
  pageX: number;
  open: (params: {
    contents?: string | ReactNode;
    pageY: number;
    pageX: number;
  }) => void;

  close: () => void;
}

export const useContextcustom = create<ContextCustomType>((set, get) => ({
  isOpen: false,
  pageY: 0,
  pageX: 0,
  open: ({ contents, pageY, pageX }) => {
    set({
      contents,
      isOpen: true,
      pageY,
      pageX
    });
  },
  close: () => set({ isOpen: false, contents: '' }, false),
  contents: '',
  loading: false
}));
